<template>
<div class="container-fluid">

<div class="card border-primary mb-3">
  <h4 class="card-header  bg-primary text-white">CONTROLLO GIFT CARD</h4>
  <div class="card-body">

    <div v-if="form_type=='validate'">

    <form v-on:submit.prevent="submit_validate()">

        <div class="form-group row">    
            <label for="inputCode" class="col-sm-2 col-form-label">CODICE GIFT CARD</label>
            <div class="col-sm-10">
            <input autocomplete="off" required v-focus type="text" class="form-control" id="inputCode" v-model="GiftCard.gc_code">
            </div>
        </div>  
            
        <div class="form-group row ml-4">
            <div class="col-sm-10">
            <button :disabled="spinner" type="submit" class="btn btn-primary">
                <span v-if="spinner" class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
                CONTROLLA</button>
            </div>
        </div>
  
    </form>
</div>  
<div v-else>

    <form v-on:submit.prevent="submit_spent()">
    
        <div class="alert alert-info border border-info" role="alert">
           <h4 class="alert-heading">GIFT CARD </h4>
            <p>CODICE <strong> {{ GiftCard.gc_code }}</strong></p>   
            <hr>
            IMPORTO DISPONIBILE  <h4><strong> € {{ fmt1(GiftCard.available_amount) }} </strong></h4>
        </div>
        
         


        <div class="form-group row">
            <label for="inputTotal" class="col-sm-2 col-form-label">IMPORTO DA SPENDERE</label>
            <div class="col-sm-10">
                <input required v-focus :max="GiftCard.available_amount" type="number" class="form-control" id="inputEmail3" v-model="GiftCard.spent_amount">
            </div>
        </div>

        <div class="form-group row ml-4">
            <div >
                <button @click="setForm('validate')" type="button" class="btn btn-secondary">ANNULLA</button>
            </div>

            <div class="col-sm-10">
                <button :disabled="spinner" type="submit" class="btn btn-primary">
                   <span v-if="spinner" class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
                  REGISTRA</button>
            </div>


        </div>
        
    </form>
</div>
 
<div v-if="spent_success" class="alert alert-success" role="alert">
  REGISTRAZIONE EFFETTUATA.
</div>

<div v-if="alert_msg" class="alert alert-danger" role="alert">
  {{ alert_msg }}
</div>

  </div>
</div>




</div>
</template>
<script>
import fmt                 from '@/components/mixins/fmt.js'
import api                 from '@/api'
import { mapGetters }      from 'vuex';
export default {
  mixins: [fmt],  
  props: [],
  data () {
    return {

      form_type     : 'validate',
      GiftCard      : {}, 
      alert_msg     : '',
      alert_warning : false,
      spinner       : false,
      spent_success : false,
      url           : 'https://kfercjn6z0.execute-api.eu-central-1.amazonaws.com/prod/'
    
      
    }
  },
    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: 
  {
    ...mapGetters(['company']) ,   
  },
  mounted()
    {      
      
    },
  methods: 
    {
   
    setForm(type)
    {   

        this.alert_msg             = ''
        this.form_type             = type
        this.GiftCard.spent_amount = ''
        this.spent_success         = false
        

    },    
    async submit_validate()
    {
    
      
      this.spinner       = true        
      this.alert_msg     = ''      
      const url          =  this.url + 'validate'      
      //const proxy        = 'validate'
      const data         = this.GiftCard    
      
      
      await api.caposerio(data,url).then(res => {
          if(res.status==200)
            {
                             
                const data         = res.data.body                                
                this.spinner       = false
                this.form_type     = data.valid == true ? 'spent' : 'validate'
                
               
                if(data.valid)
                {
                    this.GiftCard.available_amount = data.available_amount
                    this.GiftCard.gc_amount        = data.available_amount
                }    
                else
                {
                  if(data.detail)
                  {
                    this.alert_msg = data.detail  
                  }
                  else 
                  {
                    this.alert_msg = 'GIFT CARD NON VALIDA !'  
                  }
                  
                }
                
            }
        
                
            }).catch(err => {
                 this.spinner   = false
                 this.alert_msg = err
                console.log(err)  
              
            })

      
    },
      async submit_spent()
    {
      this.alert_msg     = ''
      this.spinner       = true
      this.spent_success = false      
      const url          = this.url + 'spent'
      const data         = this.GiftCard            
      await api.caposerio(data,url).then(res => {
          if(res.status==200)
            {
                this.spinner = false
                //this.GiftCard = {}
                //this.GiftCard = res.data   
                
                this.spent_success = res.data.body.success
                
                
            }
        
        console.log(res)
      }).catch(err => {
            this.spinner = false
            this.alert_msg = err
            console.log(err)  
              
          })

      
    }
    
    
    },

    
  
  
  }

</script>

<style scoped>


</style>

